import { render } from "./Projets.vue?vue&type=template&id=3b98a69e&scoped=true"
import script from "./Projets.vue?vue&type=script&lang=js"
export * from "./Projets.vue?vue&type=script&lang=js"

import "./Projets.vue?vue&type=style&index=0&id=3b98a69e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b98a69e"

export default script